// NO EDITAR A MANO
import soportados, {type Langs} from "../../../langs";

export type CmpGdprSinLogoP1Param = "brand";
export type CmpGdprSinLogoP1AppParam = "brand";
export type CmpGdprSinLogoP3Param = "cookies_policy";
export type CmpGdprSinLogoP3AppParam = "cookies_policy";
export type CmpGdprSinLogoP5Param = "cookies_policy";
export type CmpGdprSinLogoP5AppParam = "cookies_policy";

export type CmpGdprSinLogoP1Params = Record<CmpGdprSinLogoP1Param, string>;
export type CmpGdprSinLogoP1AppParams = Record<CmpGdprSinLogoP1AppParam, string>;
export type CmpGdprSinLogoP3Params = Record<CmpGdprSinLogoP3Param, string>;
export type CmpGdprSinLogoP3AppParams = Record<CmpGdprSinLogoP3AppParam, string>;
export type CmpGdprSinLogoP5Params = Record<CmpGdprSinLogoP5Param, string>;
export type CmpGdprSinLogoP5AppParams = Record<CmpGdprSinLogoP5AppParam, string>;

export interface CmpGdprSinLogo {
    alternativamente: string;
    p_1: (params?: Partial<CmpGdprSinLogoP1Params>)=>string;
    p_1_app: (params?: Partial<CmpGdprSinLogoP1AppParams>)=>string;
    p_2: string;
    p_2_app: string;
    p_3: (params?: Partial<CmpGdprSinLogoP3Params>)=>string;
    p_3_app: (params?: Partial<CmpGdprSinLogoP3AppParams>)=>string;
    p_4: string;
    p_4_app: string;
    p_5: (params?: Partial<CmpGdprSinLogoP5Params>)=>string;
    p_5_app: (params?: Partial<CmpGdprSinLogoP5AppParams>)=>string;
    p_6: string;
    st_1: string;
    st_2: string;
    st_3: string;
    st_3_app: string;
    st_4: string;
}

const loader = async function(lang: Langs, defecto?: string): Promise<CmpGdprSinLogo> {
    let langToImport = soportados.indexOf(lang)<0 ? (defecto||'en') : lang;

    return import(/* webpackChunkName: "i18n/[request]/cmp.gdpr.sin_logo" */ `../../../.src/${langToImport.replace("-", "")}/cmp/gdpr/sin_logo`).then(module=> module.default);
}

export default loader;
